export enum BranchEnums {
  //sucursales por:
  sucursalesCompañia = 1,
  sucursalesUsuario = 2
}